import { render } from "./MedicationClassCard.vue?vue&type=template&id=1023fdde"
import script from "./MedicationClassCard.vue?vue&type=script&lang=js"
export * from "./MedicationClassCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__